import { useCallback, useState } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { notificationApiRef } from '../../../../../apis/notificationApi';
import { toolsProvisioningApiRef } from '../../../../../apis/toolsProvisioningApi';
import { toExecutionDashboard } from '../dto/responseDto/runResults.response.dto';
import type { IIqeRunResultsRequest } from '../interfaces/api/requests/runResults.request';
import type { IExecutionDashboard } from '../interfaces/ui';

export const useExecutionResults = () => {
  const notificationApi = useApi(notificationApiRef);
  const toolsProvisioningApi = useApi(toolsProvisioningApiRef);
  const [data, setData] = useState<IExecutionDashboard | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const clearError = useCallback(() => setError(null), []);
  const reset = useCallback(() => {
    setData(null);
    setLoading(false);
    setError(null);
  }, []);

  const fetchResults = useCallback(
    async (request: IIqeRunResultsRequest) => {
      setLoading(true);
      setError(null);
      try {
        const response = await toolsProvisioningApi.getIqeExecutionDashboard(
          request,
        );
        setData(toExecutionDashboard(response));
      } catch (requestError) {
        const message = `Error occurred - ${requestError}`;
        setError(message);
        notificationApi.sendNotification({
          message,
          disapperAfterMs: 4000,
          severity: 'error',
        });
      } finally {
        setLoading(false);
      }
    },
    [notificationApi, toolsProvisioningApi],
  );

  return { data, loading, error, clearError, reset, fetchResults };
};
